import { httpClient } from "@coworker/http-client";
import { useQueries } from "@tanstack/react-query";
import type { Launch, LaunchMedia } from "../types/launch";

const launchMediasQueryKey = (launchId: string | undefined) =>
  ["launch-media", "launches", launchId, "medias"] as const;

export function useAllLaunchMedias(launches: Launch[]) {
  return useQueries({
    queries: launches.map((launch) => ({
      queryKey: launchMediasQueryKey(launch.id),
      queryFn: async () => {
        const response = await httpClient.mediaMgmt.get<{
          medias: LaunchMedia[];
        }>(`/launches/${encodeURIComponent(launch.id)}/medias`);
        return response.medias;
      },
    })),
    combine: (results) => {
      const mediasByLaunchId: Record<string, LaunchMedia[]> = {};
      launches.forEach((launch, index) => {
        const data = results[index]?.data;
        if (data) mediasByLaunchId[launch.id] = data;
      });
      return {
        mediasByLaunchId,
        isLoading: results.some((result) => result.isLoading),
      };
    },
  });
}
